import { Component, Output, EventEmitter, Input, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import * as moment from 'moment-timezone';
import { debounce } from 'lodash';
import { ClientResponse } from 'app/shared/graphql';
import { DateRange } from 'app/shared/utils/dates';

@Component({
    selector: 'key-date-range-select',
    templateUrl: './date-range-selection.component.html',
})
export class KeyDateRangeSelectComponent implements OnChanges, OnInit {

    @Input() currentString: string;
    @Input() date: DateRange;
    @Input() maxDays = 7;
    @Input() minDate: string;
    @Input() clearButtonArgument: string;
    @Input() addDayToNextDayCheck: boolean;
    @Input() fireDebounceLeadingEdge = true;
    @Output() onDateSelection = new EventEmitter<DateRange>();

    dateStart: string;
    dateEnd: string;

    maxDate: string = moment.utc().endOf('day').toISOString(); // NOTE: We don't support future dates at the moment, cause why would you want to select a date in the future anyways??!!??
    debounceEmitDateSelect;
    client: ClientResponse;

    get hasNextDay(): boolean {
        // add a day if the input date is the start of the date range rather than the end
        let endDate = moment.utc(this.dateStart);
        if (this.addDayToNextDayCheck) {
            endDate = endDate.add(1, 'days');
        }
        return this.dateStart && moment.utc().startOf('day').diff(endDate) > 0;
    }

    get hasPrevDay(): boolean {
        return this.minDate ? this.dateStart && moment.utc(this.minDate).startOf('day').diff(this.dateStart) < 0 : true;
    }

    constructor(
    ) {
    }

    async ngOnChanges(changes: SimpleChanges) {

        if (changes.date) {
            this.dateStart = this.date.start;
            this.dateEnd = this.date.end;
        }

    }

    ngOnInit() {
        this.debounceEmitDateSelect = debounce(this.emitDateSelect, this.fireDebounceLeadingEdge ? 1000 : 500, { leading: this.fireDebounceLeadingEdge });
    }

    getDateDiff(): number {
        return Math.ceil(moment.utc(this.dateEnd).diff(moment.utc(this.dateStart), 'hours') / 24);
    }

    doStartDateSelection(date: string) {
        if (date === 'today' || date === 'now') {
            date = moment.utc().toISOString();
        }
        this.dateStart = date;

        const diff = this.getDateDiff();
        if (diff > this.maxDays) {
            this.dateEnd = moment.utc(this.dateEnd).add(this.maxDays - diff, 'days');
        }

        this.debounceEmitDateSelect();
    }

    doEndDateSelection(date: string) {
        if (date === 'today' || date === 'now') {
            date = moment.utc().toISOString();
        }
        this.dateEnd = date;

        const diff = this.getDateDiff();
        if (diff > this.maxDays) {
            this.dateStart = moment.utc(this.dateStart).add(diff - this.maxDays, 'days');
        }

        this.debounceEmitDateSelect();
    }

    emitDateSelect() {
        this.onDateSelection.emit({
            start: this.dateStart,
            end: this.dateEnd,
        });
    }

    selectPreviousDate() {
        let date;

        if (this.dateStart) {
            date = moment.utc(this.dateStart).tz(moment.defaultZone.name).subtract(1, 'days').toISOString();
        } else {
            date = moment.utc().toISOString();
        }
        this.doStartDateSelection(date);
    }

    selectNextDate() {
        if (this.dateEnd && this.hasNextDay) {
            const date = moment.utc(this.dateEnd).tz(moment.defaultZone.name).add(1, 'days').toISOString();
            this.doEndDateSelection(date);
        }
    }


}
